<template>
  <div>
    <div class="login-register-container">
      <div class="branding">
        <img src="../../../public/FullLogoV3.webp" alt />
        <h3>Pediatric Health Consultants</h3>
      </div>
      <div class="alert">
        <p v-if="feedback" class="red-warning">{{ this.feedback }}</p>
      </div>
      <div class="login-register-wrap">
        <h3 class="title">Login to your account:</h3>
        <form @submit.prevent="login" action>
          <div class="input-field">
            <div class="label">
              <label for="email">Email:</label>
            </div>
            <input
              autocomplete="off"
              placeholder="Enter Email"
              v-model="email"
              type="text"
              id="email"
            />
          </div>
          <div class="input-field">
            <div class="label">
              <label for="password">Password:</label>
            </div>
            <input
              autocomplete="off"
              placeholder="Password"
              v-model="password"
              type="password"
              id="password"
            />
          </div>
          <button class="mt-1 btn purple">Login</button>
        </form>
      </div>
      <p class="login-register-switch">
        Dont have an account yet?
        <router-link class="link" to="/register">Sign Up</router-link>
      </p>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/auth";
export default {
  name: "Login",
  data() {
    return {
      email: null,
      password: null,
      feedback: null,
    };
  },
  methods: {
    login() {
      if (this.email && this.password) {
        firebase
          .auth()
          .signInWithEmailAndPassword(this.email, this.password)
          .then(
            () => {
              if (navigator.userAgent.indexOf("Safari") != -1) {
                this.$router.go({ path: this.$router.path });
                window.location.reload();
              } else {
                this.$router.go({ path: this.$router.path });
              }
            },
            (err) => {
              alert(err.message);
            }
          );
        this.feedback = null;
      } else {
        this.feedback = "Please fill out all fields.";
      }
    },
  },
};
</script>

<style lang="scss">
.login-register-container {
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .branding {
    color: black;
    font-size: 16px;
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    text-decoration: none;

    img {
      margin-right: 0.5rem;
      height: 60px;
    }
  }

  .branding i {
    margin-right: 0.5rem;
    color: #00afea;
  }

  .title {
    font-size: 16px;
    margin-bottom: 2rem;
  }

  .alert {
    width: 80%;
    margin-top: 1rem;
    @media (min-width: 500px) {
      width: 450px;
    }
    .red-warning {
      font-weight: 400;
      padding: 0.7rem;
      border-radius: 10px;
      color: white;
      background-color: rgba(255, 0, 0, 0.8);
      font-size: 14px;
    }
  }

  .login-register-wrap {
    border-radius: 15px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 2rem 2rem;
    margin: 1.5rem 0;
    width: 80%;
    background-color: white;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14),
      0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);

    @media (min-width: 500px) {
      width: 450px;
    }
  }

  .input-field {
    margin-bottom: 1rem;
    display: flex;
    flex-direction: column;
  }

  .label {
    margin-left: 4px;
  }

  .input-field i {
    font-size: 12px;
    margin-right: 0.2rem;
  }

  label {
    font-size: 12px;
    font-weight: 400;
  }

  input {
    font-size: 14px;
    border: none;
    border-bottom: 1px solid #979797;
    margin-top: 0.5rem;
    padding: 0.7rem 4px;
    transition: 500ms ease all;

    &:focus {
      box-shadow: 0 1px 0 0 #6236ff;
      border-color: #6236ff;
    }

    &::placeholder {
      opacity: 0.6;
    }
  }

  input:focus {
    outline: none;
  }

  .login-register-switch {
    color: #979797;
    font-size: 14px;
  }

  link {
    color: #6236ff;
  }
}
</style>
